import { type FC } from 'react';

import { type Document } from '@contentful/rich-text-types';
import { useGetZooverCompositeSearchByArgs } from '@vakantiesnl/services/src/hooks/queries';
import { defaultCompositeSearch } from '@vakantiesnl/services/src/search';
import { type FilterState } from '@vakantiesnl/services/src/stores/filtersStore';
import { getDefaultDate } from '@vakantiesnl/services/src/util/getDefaultDate';
import { type Search } from '@vakantiesnl/types/src';

import { AccoCardsGroup } from '../AccoCardsGroup';

type SmallSearchListProps = {
	title: string;
	document?: Document | null;
	variant: 'popularAccos' | 'default';
	customSearchBody?: Partial<Search.ZooverCompositeSearchBody>;
	headingClassName?: string;
	/** Filters to pass for adding filters to the url builder  */
	filters?: FilterState;
};

export const SmallSearchList: FC<SmallSearchListProps> = ({
	document,
	title,
	variant,
	customSearchBody,
	headingClassName,
	filters,
}) => {
	const { accommodationsData, isLoadingAccommodations } = useGetZooverCompositeSearchByArgs({
		departure_date: getDefaultDate(),
		...defaultCompositeSearch,
		...customSearchBody,
		filters: {
			...defaultCompositeSearch.filters,
			...customSearchBody?.filters,
		},
	});

	if (
		isLoadingAccommodations ||
		!accommodationsData?.accommodations.length ||
		accommodationsData?.accommodations.length === 0
	)
		return null;

	return (
		<AccoCardsGroup
			accos={accommodationsData.accommodations}
			heading={title}
			headingClassName={headingClassName}
			document={document}
			filters={filters}
			accoCardSize="micro"
			listDataCy={variant === 'popularAccos' ? 'popularAccosList' : 'accoList'}
			needQueryParams={variant === 'popularAccos' || !!customSearchBody}
			withScrollButtons={accommodationsData.accommodations.length > 4}
			needsDurationOverride={!!customSearchBody?.filters?.durations_flight}
		/>
	);
};
